import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20fashion%20shopping%20essentials%20sneakers%20sunglasses%20watch%20backpack%20wallet%20arranged%20on%20warm%20terracotta%20surface%20soft%20golden%20hour%20lighting%20editorial%20product%20photography%20cream%20beige%20and%20deep%20warm%20brown%20tones%20clean%20minimalist%20aesthetic%20high%20detail%20no%20text%20no%20logos&width=1800&height=1000&seq=oopbuy-hero-bg-001&orientation=landscape"
        alt="OOPBuy Spreadsheet Deutschland – Moderne Streetwear Fashion Übersicht"
        title="OOPBuy Spreadsheet Deutschland – Beste Produktlisten &amp; Finds"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-6">
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white font-bold leading-tight tracking-tight mb-6">
          OOPBuy Spreadsheet – Die beste Übersicht für Produkte, Finds und Shopping Guides
        </h1>
        <p className="text-white/85 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Finde die beliebtesten OOPBuy Produkte schneller. Unser OOPBuy Spreadsheet sammelt
          Kategorien, Trends, Empfehlungen und hilfreiche Informationen für deutsche Nutzer.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-store-2-line text-lg"></i>
            <span>OOPBuy Spreadsheet entdecken</span>
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-white/50 text-white font-semibold text-base hover:bg-white/15 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line text-lg"></i>
            <span>Buy It Now</span>
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
        <p className="text-white/60 text-sm mt-8">
          Kostenlose Übersicht &bull; Kategorien sortiert &bull; Für deutsche Nutzer optimiert
        </p>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl animate-bounce"></i>
      </div>
    </section>
  );
}